module.exports = __webpack_public_path__ + "img/basic_trialset_202410.4393ed1f.jpg";